export default __webpack_public_path__ + "static/media/Maytag@2x.ac24ec15.png";